import type { InvestigationEntity } from '@features/investigations';
import type { InvestigationPrintData, InvestigationPrintInvolvedEmployee } from '../interfaces/investigation-print-data.interface';
import { formatDateForPrint } from './case-print.util';

export function mapInvestigationToPrintData(
  investigation: InvestigationEntity,
  fieldValues: { label: string; value: string }[],
  involvedEmployees?: { firstName: string; lastName: string; email: string }[]
): InvestigationPrintData {
  return {
    investigationNumber: investigation.investigationNumber,
    investigationType: investigation.investigationTypeName ?? '',
    category: investigation.investigationTypeCategoryName ?? '',
    createdBy: investigation.createdByUserName ?? '',
    created: formatDateForPrint(investigation.createdOn),
    dueDate: investigation.dueDate ? formatDateForPrint(investigation.dueDate) : undefined,
    status: investigation.statusDisplayName ?? '',
    statusCategoryName: investigation.statusCategoryName,
    priority: investigation.priorityName ?? '',
    primaryAssignee: investigation.primaryAssigneeName || 'Unassigned',
    secondaryAssignee: investigation.secondaryAssigneeName || 'Unassigned',
    requestorName: investigation.requestedByName ?? '',
    requestorEmail: investigation.requestedByEmail ?? '',
    requestorPhone: investigation.requestedByPhone ?? undefined,
    involvedEmployees: mapPrintInvolvedEmployees(involvedEmployees),
    closingNotes: investigation.closingNotes,
    description: extractDescriptionFromFields(fieldValues),
  };
}

function mapPrintInvolvedEmployees(
  employees?: { firstName: string; lastName: string; email: string }[]
): InvestigationPrintInvolvedEmployee[] {
  if (!employees || employees.length === 0) return [];
  return employees.map((e) => ({
    name: `${e.firstName} ${e.lastName}`,
    email: e.email,
  }));
}

function extractDescriptionFromFields(fields: { label: string; value: string }[]): string | undefined {
  const descLabels = ['description', 'details', 'summary', 'notes', 'comments'];
  return fields.find((f) => descLabels.some((l) => f.label.toLowerCase().includes(l)))?.value;
}
